<div class="taxi-search-container" [class.results-mode]="resultsMode">
  @if (searchParams?.clonedBasketItemDetails?.supplierName) {
    <div>
      <app-cloned-details
        [name]="searchParams?.clonedBasketItemDetails?.supplierName"
      ></app-cloned-details>
    </div>
  }
  <p class="required-fields-notice">
    <span i18n="@@requiredFieldsNotice">Fields marked with an asterisk (*) are required.</span>
  </p>
  <div class="location-form-container">
    <span id="aria-taxi-pickup-address" hidden i18n="@@carSearchPickupLocationAirport"
      >Pick-up location</span
    >
    <div>
      <app-taxi-multi-location-form
        [(address)]="searchParams.fromAddress"
        [(station)]="searchParams.fromStation"
        [required]="true"
        [modeType]="searchParams.mode"
        [limo]="searchParams.vehicleType === CabHireVehicleType.Limo"
        [isCmacOnly]="hasCmac && !hasGroundspan && !hasGroundscope"
        i18n-title
        title="Pick-up location"
        i18n-legendTitle
        legendTitle="Pick-up"
        (addressChanged)="fromAddressChange($event)"
        (locationChange)="stationChange($event)"
        aria-labelledby="aria-taxi-pickup-address"
        [showDateBlock]="true"
        [hasGroundspan]="hasGroundspan"
        [transTypes]="transTypes"
        [limoDurations]="limoDurations"
      >
      </app-taxi-multi-location-form>
    </div>
  </div>
  <div class="location-form-container">
    <span id="aria-taxi-dropoff-address" hidden i18n="@@AriaTaxiDropoffAddress"
      >Drop-off address</span
    >
    <div>
      <app-taxi-multi-location-form
        [(address)]="searchParams.toAddress"
        [(station)]="searchParams.toStation"
        [isCmacOnly]="hasCmac && !hasGroundspan && !hasGroundscope"
        (addressChanged)="toAddressChange($event)"
        (locationChange)="stationChange($event, true)"
        [modeType]="searchParams.modeTo"
        [limo]="searchParams.vehicleType === CabHireVehicleType.Limo"
        [required]="true"
        i18n-title
        title="Drop-off location"
        i18n-legendTitle
        legendTitle="Drop-off"
        aria-labelledby="aria-taxi-dropoff-address"
        (addStopChange)="addStop($event)"
        [isStopChecked]="showStopToggle"
      ></app-taxi-multi-location-form>
    </div>
    @if (showStopToggle) {
      <span id="aria-taxi-via-address2" hidden i18n="@@AriaTaxiViaAddress2"
        >Second via address</span
      >
      <app-taxi-multi-location-form
        [(address)]="searchParams.viasTo"
        class="accordion-margin-top"
        i18n-title
        title="Stop"
        [isCmacOnly]="hasCmac && !hasGroundspan && !hasGroundscope"
        [limo]="searchParams.vehicleType === CabHireVehicleType.Limo"
        [isVia]="showStopToggle"
        (addressChanged)="viaDropoffAddress($event)"
        (locationChange)="viaDropoffChange($event)"
        aria-labelledby="aria-taxi-via-address2"
      ></app-taxi-multi-location-form>
    }
  </div>
  @if (resultsMode) {
    <div class="flex-row-container flex-row-container--right">
      <button
        (click)="search()"
        [disabled]="!searchParams.fromAddress?.PostCode || !searchParams.toAddress?.PostCode"
        appButton="large-search"
        i18n="@@taxiSearchSearch"
      >
        Search
      </button>
    </div>
  }
</div>
